import React, { useEffect, useState } from "react";
import './x-wallet.scss';

import LogoIcon from './images/x-wallet-dark.svg';
import FacebookIcon from './images/facebook.svg';
import instagramIcon from './images/instagram.svg';
import LinkedInIcon from './images/LinkedIn.svg';
import RedditIcon from './images/Reddit.svg';
import twitterIcon from './images/twitter.svg';
import YouTubeIcon from './images/YouTube.svg';
import SocialSentIcon from './images/social-sent.svg';
import discordIcon from './images/discord.svg';
import mediumIcon from './images/medium.svg';
import spotifyIcon from './images/spotify.svg';
import BlogIcon from './images/blog.svg';
import { useNavigate } from 'react-router-dom';

const TermsConditions = () => {
  const navigate = useNavigate();


  return (
    <div className='landingpage-x-wallet'>
      <div className='wallet-menu'>
        <div className="container">
          <div className='menu-inner'>
            <a href='/' className='logo'><img src={LogoIcon} /></a>
            <ul>
              <li>
                <a href='/'>Home</a>
              </li>
              <li>
                <a href='/terms-conditions'>Terms & Conditions</a>
              </li>
              <li>
                <a href='/privacy-policy'>Privacy Policy</a>
              </li>
              <li>
                <a href='https://chromewebstore.google.com/detail/xwallet/pofheakpngfbdfeidiippmmckgpdceoh' className='download-wallet' target='_blank'>

                  <svg class="wallet-icon" viewBox="0 0 24 24">
                    <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
                  </svg>
                  Download Wallet
                  <svg class="download-icon" viewBox="0 0 24 24">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container"></div>
      <div className='terms-conditions-main'>
        <div className='terms-conditions-header'>
          <div className="container">
            <h2>X_WALLET PRIVACY POLICY</h2>
          </div>
        </div>
        <div className="container">
          <div className='terms-conditions-body'>
            <div className='group-terms-p'>
              <h4>1. INTRODUCTION</h4>
              <ul>
                <li>This Privacy Policy ("Policy") describes how L1X Stiftung c/o Sielva Management SA, Gubelstrasse 11, CH-6300 Zug, Switzerland ("we," "us," "our," "L1X," or "Company") collects, uses, stores, and protects information in connection with your use of the X_Wallet browser extension and all related software and services (the "Wallet"). The Wallet is published on the Chrome Web Store by Alphabright Digital Pty Ltd (L 11 125 St Georges Tce Perth, WA 6000 AU) on behalf of L1X Stiftung.</li>
                <li>By downloading, installing, or using the Wallet, you acknowledge that you have read and understood this Policy. This Policy should be read together with our Terms and Conditions available at <a href='https://www.wallet.l1x.foundation/terms-conditions' target='_blank'>https://www.wallet.l1x.foundation/terms-conditions</a>.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>2. NON-CUSTODIAL DESIGN — WHAT WE DO NOT COLLECT</h4>
              <ul>
                <li>X_Wallet is a non-custodial wallet. By design, we do not have access to, collect, store, transmit, or process any of the following:</li>
                <li>
                  <ul>
                    <li>a. Your private keys or secret recovery phrases (seed phrases);</li>
                    <li>b. Your wallet passwords or encryption credentials;</li>
                    <li>c. Your wallet balances or portfolio holdings;</li>
                    <li>d. Your transaction history, transaction details, or transaction amounts;</li>
                    <li>e. The contents of any transaction you sign or approve;</li>
                    <li>f. Your digital asset holdings or token balances;</li>
                    <li>g. Any blockchain addresses associated with your Wallet, unless you voluntarily provide them to us (e.g., in a support request).</li>
                  </ul>
                </li>
                <li>All of the above data is stored locally on your device and encrypted using your own credentials. We have no ability to access, retrieve, decrypt, or recover this data. If you lose your private key or recovery phrase, we cannot help you recover access to your Wallet or funds.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>3. INFORMATION WE MAY COLLECT</h4>
              <ul>
                <li><span>3.1 Information You Voluntarily Provide.</span> We may collect personal information that you voluntarily provide to us, including but not limited to:</li>
                <li>
                  <ul>
                    <li>a. Your name, email address, and contact details;</li>
                    <li>b. Account registration information, if you create an account with us;</li>
                    <li>c. The content of your communications with us (support requests, feedback, inquiries);</li>
                    <li>d. Wallet addresses or transaction identifiers you voluntarily share with us (e.g., in a support request);</li>
                    <li>e. Survey responses, feedback, or preferences you choose to provide;</li>
                    <li>f. Any other information you choose to submit to us.</li>
                  </ul>
                </li>
                <li>You are under no obligation to provide this information, but certain features or services may not be available without it.</li>
                <li><span>3.2 Automatically Collected Information.</span> When you use the Wallet, we may automatically collect certain technical and usage information, including but not limited to:</li>
                <li>
                  <ul>
                    <li>a. Device information: Device type, operating system, browser type and version, screen resolution, language settings, and unique device identifiers;</li>
                    <li>b. Usage data: Features used, actions taken within the Wallet, session duration, frequency of use, navigation patterns, and interaction data;</li>
                    <li>c. Performance data: Crash reports, error logs, load times, and diagnostic information;</li>
                    <li>d. Network information: IP address (which may be anonymised or truncated), internet service provider, and general geographic location (city/country level, not precise location);</li>
                    <li>e. Referral data: How you discovered or installed the Wallet.</li>
                  </ul>
                </li>
                <li>This data is collected in aggregate and anonymised form wherever possible. We use this data solely to improve the Wallet's functionality, stability, and user experience. We do not use automatically collected data to identify individual users, track individual transactions, or monitor individual wallet activity.</li>
                <li>We may use third-party analytics services (such as PostHog, Mixpanel, or similar tools) to process this data on our behalf. These services are contractually bound to process data only as instructed by us and in accordance with this Policy.</li>
                <li>You may opt out of analytics collection through the Wallet settings where such an option is provided. Opting out will not affect the core functionality of the Wallet.</li>
                <li><span>3.3 Cookies and Similar Technologies.</span> The Wallet or our website may use cookies, local storage, or similar technologies for the following purposes:</li>
                <li>
                  <ul>
                    <li>a. Essential functionality: Remembering your preferences and settings;</li>
                    <li>b. Analytics: Understanding how the Wallet and website are used (in aggregate);</li>
                    <li>c. Performance: Monitoring and improving service performance.</li>
                  </ul>
                </li>
                <li>We do not use cookies or similar technologies for advertising, cross-site tracking, or profiling. You may disable non-essential cookies through your browser settings. Disabling essential cookies may affect the functionality of the Wallet or website.</li>
                <li><span>3.4 Information Collected by the Chrome Web Store.</span> When you download the Wallet from the Chrome Web Store, Google may collect information about the download in accordance with Google's own privacy policy. We do not control and are not responsible for Google's data collection practices.</li>
                <li><span>3.5 Blockchain Data.</span> When you use the Wallet to interact with blockchain networks, your transactions are recorded on the public blockchain. This data is publicly visible and permanently recorded by the blockchain protocol itself, not by us. We have no control over, and assume no responsibility for, blockchain data.</li>
                <li><span>3.6 Information from Third-Party Sources.</span> We may receive information about you from third-party sources, including but not limited to:</li>
                <li>
                  <ul>
                    <li>a. Blockchain analytics providers (publicly available on-chain data only);</li>
                    <li>b. Identity verification services, if we implement such features in the future;</li>
                    <li>c. Public databases and government records, for compliance purposes.</li>
                  </ul>
                </li>
                <li>Any information received from third-party sources will be processed in accordance with this Policy.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>4. HOW WE USE INFORMATION</h4>
              <ul>
                <li>We may use the information we collect for the following purposes:</li>
                <li>
                  <ul>
                    <li>a. Service delivery: To provide, maintain, and improve the Wallet and related services;</li>
                    <li>b. Product development: To develop new features, analyse usage trends, and improve user experience;</li>
                    <li>c. Analytics: To understand how the Wallet is used in aggregate, identify bugs, and optimise performance;</li>
                    <li>d. Communications: To respond to your support requests, send service-related notices, and provide updates about the Wallet;</li>
                    <li>e. Security: To detect, prevent, and address fraud, abuse, security risks, and technical issues;</li>
                    <li>f. Legal compliance: To comply with applicable laws, regulations, and legal obligations;</li>
                    <li>g. Enforcement: To enforce our Terms and Conditions;</li>
                    <li>h. Protection: To protect our rights, property, and safety, and the rights, property, and safety of our users and the public;</li>
                    <li>i. Research: To conduct research and analysis for the improvement of our services (using anonymised or aggregated data where possible);</li>
                    <li>j. Any other purpose disclosed to you at the time of collection or with your consent.</li>
                  </ul>
                </li>
                <li>We do not sell your personal information to third parties. We do not use your information for targeted advertising or individual profiling. We do not use automated decision-making that produces legal effects concerning you.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>5. LEGAL BASIS FOR PROCESSING</h4>
              <ul>
                <li>Where applicable under the FADP, GDPR, or similar laws, we process your personal information on the following legal bases:</li>
                <li>
                  <ul>
                    <li>a. Consent: Where you have given us clear consent to process your personal information for a specific purpose (e.g., opting in to analytics);</li>
                    <li>b. Contract performance: Where processing is necessary for the performance of our agreement with you (e.g., providing the Wallet and support services);</li>
                    <li>c. Legitimate interests: Where processing is necessary for our legitimate interests and those interests are not overridden by your data protection rights. Our legitimate interests include improving the Wallet, ensuring security, preventing fraud, and understanding aggregate usage patterns;</li>
                    <li>d. Legal obligation: Where processing is necessary for compliance with a legal obligation to which we are subject.</li>
                  </ul>
                </li>
                <li>Where we rely on consent, you have the right to withdraw that consent at any time. Where we rely on legitimate interests, you have the right to object to such processing.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>6. DATA SHARING AND DISCLOSURE</h4>
              <ul>
                <li>We do not sell, rent, trade, or otherwise share your personal information with third parties for their commercial or advertising purposes.</li>
                <li>We may share information in the following circumstances:</li>
                <li>
                  <ul>
                    <li>a. Service providers: We may share information with third-party service providers who perform services on our behalf, including but not limited to cloud hosting, analytics, error monitoring, customer support tools, and email delivery. These providers are contractually obligated to use your information only as directed by us and in accordance with this Policy;</li>
                    <li>b. Affiliates: We may share information with our corporate affiliates, subsidiaries, and related entities for the purposes described in this Policy;</li>
                    <li>c. Legal compliance: When required by law, regulation, legal process, subpoena, court order, or government request;</li>
                    <li>d. Protection of rights: To protect the rights, property, or safety of the Company, our users, or the public;</li>
                    <li>e. Enforcement: To enforce our Terms and Conditions;</li>
                    <li>f. Consent: With your explicit consent;</li>
                    <li>g. Business transfers: In connection with a merger, acquisition, reorganisation, or sale of all or a portion of our assets, in which case your information may be transferred as part of that transaction. We will notify you of any change in ownership or use of your information;</li>
                    <li>h. Aggregated or anonymised data: We may share aggregated or anonymised information that cannot reasonably be used to identify you, without restriction.</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>7. DATA STORAGE AND SECURITY</h4>
              <ul>
                <li><span>7.1 Local Storage.</span> All wallet data (private keys, recovery phrases, account information, transaction data) is stored locally on your device using encrypted storage provided by the Chrome browser extension platform. This data never leaves your device through the Wallet.</li>
                <li><span>7.2 Security Measures.</span> We implement commercially reasonable technical and organisational measures to protect any information we hold. However, no method of electronic storage or transmission is completely secure, and we cannot guarantee absolute security.</li>
                <li><span>7.3 Your Responsibility.</span> You are solely responsible for the security of your device, your private keys, your recovery phrase, and any credentials associated with your Wallet. We strongly recommend that you:</li>
                <li>
                  <ul>
                    <li>a. Keep your device software and browser up to date;</li>
                    <li>b. Use strong, unique passwords;</li>
                    <li>c. Store your recovery phrase offline in a secure location;</li>
                    <li>d. Never share your private keys, recovery phrase, or passwords with anyone;</li>
                    <li>e. Use anti-virus and anti-malware software.</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>8. DATA RETENTION</h4>
              <ul>
                <li><span>8.1 General Retention.</span> We retain personal information for as long as necessary to fulfil the purposes for which it was collected, including to satisfy any legal, accounting, regulatory, or reporting requirements. When determining the appropriate retention period, we consider the amount, nature, and sensitivity of the data, the potential risk of harm from unauthorised use or disclosure, and applicable legal requirements.</li>
                <li><span>8.2 Support Communications.</span> If you contact us, we retain your communications for as long as necessary to resolve your inquiry and for a reasonable period thereafter. We will delete support correspondence within 24 months of the resolution of your inquiry unless longer retention is required by law.</li>
                <li><span>8.3 Analytics Data.</span> Aggregated and anonymised analytics data may be retained indefinitely as it cannot be used to identify individual users. Non-anonymised usage data, if any, will be deleted or anonymised within 24 months of collection.</li>
                <li><span>8.4 Local Data.</span> Wallet data stored on your device remains on your device until you delete it by uninstalling the Wallet or clearing extension data. We have no access to and no control over this locally stored data.</li>
                <li><span>8.5 Backup and Archive Data.</span> Information may persist in our backup and disaster recovery systems for a reasonable period after deletion from our active systems. We apply the same security protections to backup data as to active data.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>9. YOUR RIGHTS</h4>
              <ul>
                <li>Depending on your jurisdiction, you may have certain rights regarding your personal information. To the extent applicable under the Swiss Federal Act on Data Protection (FADP), the EU General Data Protection Regulation (GDPR), or other applicable data protection laws, you may have the right to:</li>
                <li>
                  <ul>
                    <li>a. Access: Request confirmation of whether we process your personal data and, if so, obtain a copy;</li>
                    <li>b. Correction: Request correction of inaccurate or incomplete personal data;</li>
                    <li>c. Deletion: Request deletion of your personal data, subject to certain exceptions;</li>
                    <li>d. Restriction: Request restriction of processing of your personal data;</li>
                    <li>e. Portability: Request transfer of your personal data in a structured, commonly used, machine-readable format;</li>
                    <li>f. Objection: Object to the processing of your personal data;</li>
                    <li>g. Withdrawal of consent: Withdraw your consent at any time where processing is based on consent.</li>
                  </ul>
                </li>
                <li>To exercise any of these rights, contact us at <a href='mailto:info@l1x.foundation'>info@l1x.foundation</a>. We will respond to your request within 30 days.</li>
                <li>Please note: Because the Wallet is non-custodial and we do not collect or store wallet-related data, most of these rights will not be applicable in practice. We cannot provide, correct, or delete data we do not have.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>10. DO NOT TRACK</h4>
              <ul>
                <li>There is currently no uniform technology standard for recognising and implementing Do Not Track (DNT) browser signals. We do not currently respond to DNT signals. If a standard for responding to DNT signals is established in the future, we will reassess our approach and update this Policy accordingly.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>11. CHILDREN'S PRIVACY</h4>
              <ul>
                <li>The Wallet is not intended for use by individuals under the age of 18 (or the age of majority in your jurisdiction). We do not knowingly collect personal information from children. If we become aware that we have collected personal information from a child, we will take steps to delete such information promptly.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>12. INTERNATIONAL DATA TRANSFERS</h4>
              <ul>
                <li>If you are located outside Switzerland, any information you voluntarily provide to us (e.g., through support communications) may be transferred to and processed in Switzerland. By providing us with information, you consent to such transfer and processing. Switzerland has been recognised by the European Commission as providing an adequate level of data protection.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>13. THIRD-PARTY SERVICES</h4>
              <ul>
                <li>The Wallet allows you to interact with third-party blockchain networks, smart contracts, decentralised applications, and other third-party services. These third parties may collect data about you in accordance with their own privacy policies. We have no control over and assume no responsibility for the data collection practices of any third party. We encourage you to review the privacy policies of any third-party services you interact with through the Wallet.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>14. CHANGES TO THIS POLICY</h4>
              <ul>
                <li>We may update this Policy from time to time. The most current version will always be available at <a href='https://www.wallet.l1x.foundation/privacy-policy' target='_blank'>https://www.wallet.l1x.foundation/privacy-policy</a>. We will indicate the date of the most recent update at the top of this Policy. Your continued use of the Wallet after any changes constitutes your acceptance of the updated Policy.</li>
                <li>If we make material changes that significantly affect how we handle personal information, we will provide prominent notice through the Wallet or the Chrome Web Store listing before the changes take effect.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>15. DATA PROTECTION AUTHORITIES</h4>
              <ul>
                <li>If you believe that we have not complied with applicable data protection laws, you have the right to lodge a complaint with the relevant data protection authority:</li>
                <li>
                  <ul>
                    <li>a. Switzerland: Federal Data Protection and Information Commissioner (FDPIC), <a href='https://www.edoeb.admin.ch' target='_blank'>https://www.edoeb.admin.ch</a></li>
                    <li>b. European Union: Your local supervisory authority under the GDPR</li>
                    <li>c. Other jurisdictions: The relevant data protection authority in your country of residence</li>
                  </ul>
                </li>
                <li>We encourage you to contact us first at <a href='mailto:info@l1x.foundation'>info@l1x.foundation</a> so we can try to resolve your concern directly.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>16. LIMITATION OF LIABILITY FOR DATA</h4>
              <ul>
                <li>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WE SHALL NOT BE LIABLE FOR ANY LOSS, DAMAGE, OR CLAIM ARISING FROM OR RELATING TO:</li>
                <li>
                  <ul>
                    <li>a. Unauthorised access to data stored locally on your device, including access resulting from malware, phishing, device theft, or any other security breach of your device;</li>
                    <li>b. Your failure to adequately secure your device, private keys, recovery phrase, or credentials;</li>
                    <li>c. Any data processed by third-party blockchain networks, which is publicly visible and permanently recorded outside our control;</li>
                    <li>d. Any data collected by third-party services you interact with through the Wallet;</li>
                    <li>e. Any data collected by Google in connection with the Chrome Web Store;</li>
                    <li>f. Any data processed by third-party analytics or service providers engaged by us, to the extent such loss results from the acts or omissions of such third parties;</li>
                    <li>g. Any inaccuracy, incompleteness, or delay in any data or information provided through or in connection with the Wallet;</li>
                    <li>h. Any decision you make based on data or information provided through the Wallet.</li>
                  </ul>
                </li>
                <li>Your use of the Wallet and any data stored locally on your device is entirely at your own risk. We provide the Wallet and all related data and information on an "as is" and "as available" basis without warranties of any kind.</li>
              </ul>
            </div>
            <div className='group-terms-p'>
              <h4>17. CONTACT</h4>
              <ul>
                <li>For privacy-related questions, requests, or complaints, contact us at:</li>
                <li>L1X Stiftung c/o Sielva Management SA</li>
                <li>Gubelstrasse 11, CH-6300 Zug, Switzerland</li>
                <li>Email: <a href='mailto:info@l1x.foundation'>info@l1x.foundation</a></li>
                <li>We aim to respond to all privacy inquiries within 30 days.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='footer-section-homepage'>
        <div className="container">
          <div className='flex-footer-section'>
            <p>
              © 2025 All Rights Reserved | L1X Foundation
            </p>

            <ul className='social-ul'>
              <li>
                <a href='https://www.facebook.com/LayerOneX/' target='_blank'>
                  <img src={FacebookIcon} />
                </a>
              </li>

              <li>
                <a href='https://t.me/Layer1X' target='_blank'>
                  <img src={SocialSentIcon} />
                </a>
              </li>
              <li>
                <a href='https://discord.com/invite/LayerOneX' target='_blank'>
                  <img src={discordIcon} />
                </a>
              </li>
              <li>
                <a href='https://open.spotify.com/show/03qULl4aEnBIR1VYJqxWx7' target='_blank'>
                  <img src={spotifyIcon} />
                </a>
              </li>

              <li>
                <a href='https://medium.com/@Layeronex' target='_blank'>
                  <img src={mediumIcon} />
                </a>
              </li>

              <li>
                <a href='https://www.instagram.com/layerone_x/' target='_blank'>
                  <img src={instagramIcon} />
                </a>
              </li>
              <li>
                <a href='https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Flayer-one-x%2Fmycompany%2Fverification%2F' target='_blank'>
                  <img src={LinkedInIcon} />
                </a>
              </li>

              <li>
                <a href='https://x.com/LayerOneX' target='_blank'>
                  <img src={twitterIcon} />
                </a>
              </li>
              <li>
                <a href='https://www.youtube.com/@LayerOneX' target='_blank'>
                  <img src={YouTubeIcon} />
                </a>
              </li>
              <li>
                <a href='https://www.reddit.com/r/LayerOneX/?rdt=34212' target='_blank'>
                  <img src={RedditIcon} />
                </a>
              </li>
              <li>
                <a href='https://blog.l1x.foundation/' target='_blank'>
                  <img src={BlogIcon} />
                </a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>

  )
}

export default TermsConditions
